import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { H3Directive, SmallDirective } from '@shared/directives/typography';

@Component({
  selector: 'app-sidebar-section',
  standalone: true,
  imports: [H3Directive, SmallDirective],
  template: `
    <section class="sidebar-section">
      <div class="section-header">
        <h3 [id]="headerId" appH3>{{ title() }}</h3>
        @if (description()) {
          <p [id]="descriptionId" appSmall class="description">
            {{ description() }}
          </p>
        }
      </div>

      <div class="section-content">
        <ng-content />
      </div>
    </section>
  `,
  styles: [
    `
      .section-header {
        margin-bottom: 1rem;

        h3 {
          color: var(--md-sys-color-on-surface);
          margin: 0 0 0.25rem 0;
        }

        .description {
          color: var(--md-sys-color-on-surface-variant);
          margin: 0;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarSectionComponent {
  title = input.required<string>();
  description = input<string>();

  // Expose IDs for aria-labelledby/describedby usage by projected content
  headerId = `sidebar-section-${crypto.randomUUID().slice(0, 8)}`;
  descriptionId = `${this.headerId}-desc`;
}
